import { useSmartQuery, useAssertSmartQuery } from "hooks/useSmartQuery"
import { ROOT_QUERY } from "graphql/queries/user"

import {
  RootQuery,
  RootQueryVariables,
  RootQueryUserFragment,
  GetDisplayedProductsFragment,
  GetCurrentOfferFragment,
  GetPricingFragment,
  MediaSetAttributesFragment
} from "typings/types"

export type CurrentUser = RootQueryUserFragment
export type CurrentOffer = GetCurrentOfferFragment
export type CurrentProducts = GetDisplayedProductsFragment
export type CurrentPricing = GetPricingFragment
export type MediaSet = MediaSetAttributesFragment

/**
 * Runs the basic user query
 */
export const useRootQuery = () => useSmartQuery<RootQuery, RootQueryVariables>(ROOT_QUERY)

/**
 * Assert that the app has been loaded
 */
export const useAssertRootQueryLoaded = () => {
  const result = useAssertSmartQuery<RootQuery, RootQueryVariables>(ROOT_QUERY)

  if (result.loading) throw new Error("Unexpected: user should have already been loaded.")

  return result.data
}

/**
 * Assert that a user has been loaded already and exists
 */
export const useAssertValidRootQuery = () => {
  const data = useAssertRootQueryLoaded()

  if (!data.user) throw new Error("Unexpected: user is undefined.")

  return {
    user: data.user,
    currentOffer: data.currentOffer,
    flipperFlags: data.flipperFlags
  }
}
